/* global window */
function dpr() {
  return window.devicePixelRatio || 1;
}

function thinLineWidth() {
  return dpr() - 0.5;
}

function npx(px) {
  return parseInt(px * dpr(), 10);
}

function npxLine(px) {
  const n = npx(px);
  return n > 0 ? n - 0.5 : 0.5;
}

//获取arr中第一个连续空格输出的空格合并字符串以及总共合并了几项
//arr是一个第一个元素以空格开头的数组
function getContinuousSpace(arr){
  let total = 0;
  let mergeSpace = '';
  for (let index = 0; index < arr.length; index++) {
    const str = arr[index];
    if (str==' ') {
      if (total>0) {
        mergeSpace += ' ';
      }
      total++;
    }else{
      break;
    }
  }
  return {
    index:total,
    mergeSpaceStr:mergeSpace
  }
}

//将字符串数组中连续的空格项合并成一个，输出新的数组,去除前后空格字符串
//例如 ['2', ' ', ' ', ' ','4',' ','5',' ',' ',' '],输出 ['2', '  ', '4',' ', '5']
function mergeSpaceArray(arr){
  let resultArr = [];
  let totalIndex = 0;
  if (arr) {
    arr.forEach((str,index) => {
      if (str!=' ') {
        resultArr.push(str);
        totalIndex = index;
      }else{
        if (totalIndex<=index) {
          //如果是空格，则获取是否存在连续空格项
          let continuousSpace = getContinuousSpace(arr.slice(index))
          let mergeSpaceStr = continuousSpace.mergeSpaceStr;
          let totalMerge = continuousSpace.index;
          if (mergeSpaceStr != '') {
            resultArr.push(mergeSpaceStr);
            totalIndex = index;
            totalIndex += totalMerge
          } else {
            resultArr.push(' ');
            totalIndex = index;
          }
        }
      }
    });
  }

  if (resultArr.length>0) {
    //去除前后空格字符串
    let firstStr = resultArr[0];
    let endStr = resultArr[resultArr.length-1];

    let strFirst = firstStr.replace(/\s/g,"");
    let strEnd = endStr.replace(/\s/g,"");
    if (resultArr.length-1 == 0) {
      if (strFirst=='') {
        resultArr.splice(0,1);
      }
    } else {
      if (strFirst=='') {
        resultArr.splice(0,1);
      }
      if (strEnd=='') {
        resultArr.splice(resultArr.length-1,1);
      }
    }
  }

  return resultArr
}

function parseTexts(textStr,isFilterSpace=false){
  let reg = /[^\x00-\xff]/ig;

  let parseText = (text)=>{
    let resultArr = []
    //字符串按照中文分割，输出非中文数组
    let noZhArr = text.split(reg);
    console.log("text 去除中文......", noZhArr);
    console.log("text 去除中文......", text.length);
    let textIndex = 0;
    //根据输出的数组，获取最终的分割数组
    noZhArr.forEach((str,index) => {
      if (str) {
        resultArr.push(str);
        if (str.length) {
          textIndex = textIndex+str.length
        }
      }
      if (text[textIndex]) {
        resultArr.push(text[textIndex]);
        textIndex+=1;
      }
    });

    return resultArr;
  }
  // textStr = "0 1 34 56   abc  23 中文中文中文中文45中文67中a434文89中文撒旦法是 （）@%《";
  //先使用空格分割得出数组
  let spaceArr = textStr.split(' ');
  let newSpaceArr = []
  spaceArr.forEach((text,index) => {
    if (text=='') {
      newSpaceArr.push(' ');
    }else{
      newSpaceArr.push(text);
      if (index<spaceArr.length-1) {
        newSpaceArr.push(' ');
      }
    }
  });
  
  console.log("str 分开空格......", newSpaceArr);

  //分离空格数组中字符串
  let resultArr = []
  newSpaceArr.forEach((text,index) => {
    let regRes = new RegExp(reg)
    if(regRes.test(text)){
      resultArr = resultArr.concat(parseText(text))
    }else{
      resultArr.push(text)
    }
  });
  //先使用空格分割得出数组
  console.log("str 分开中文......", resultArr);
  //是否过滤空格
  if (isFilterSpace) {
    //将数组中连续的空格合并输出新的结果
    resultArr = mergeSpaceArray(resultArr);
    //过滤空格
    resultArr = resultArr.filter(txt=>txt != ' ')
  }

  return resultArr;
}

class DrawBox {
  constructor(x, y, w, h, padding = 0) {
    this.x = x;
    this.y = y;
    this.width = w;
    this.height = h;
    this.padding = padding;
    this.bgcolor = '#ffffff';
    // border: [width, style, color]
    this.borderTop = null;
    this.borderRight = null;
    this.borderBottom = null;
    this.borderLeft = null;
    this.imgBase64 = null;
  }

  setImgBase64(imageBase64){
    if (imageBase64) this.imgBase64 = imageBase64;
  }

  setBorders({
    top, bottom, left, right,
  }) {
    if (top) this.borderTop = top;
    if (right) this.borderRight = right;
    if (bottom) this.borderBottom = bottom;
    if (left) this.borderLeft = left;
  }

  innerWidth() {
    return this.width - (this.padding * 2) - 2;
  }

  innerHeight() {
    return this.height - (this.padding * 2) - 2;
  }

  textx(align) {
    const { width, padding } = this;
    let { x } = this;
    if (align === 'left' || align === 'horizontal-justifyAlign' || align === 'horizontal-disttibuted') {
      x += padding;
    } else if (align === 'center') {
      x += width / 2;
    } else if (align === 'right') {
      x += width - padding;
    }
    return x;
  }

  texty(align, h) {
    const { height, padding } = this;
    let { y } = this;
    if (align === 'top') {
      y += padding;
    } else if (align === 'middle' || align === 'vertical-justifyAlign' || align === 'vertical-disttibuted') {
      y += height / 2 - h / 2;
    } else if (align === 'bottom') {
      y += height - padding - h;
    }
    return y;
  }

  topxys() {
    const { x, y, width } = this;
    return [[x, y], [x + width, y]];
  }

  rightxys() {
    const {
      x, y, width, height,
    } = this;
    return [[x + width, y], [x + width, y + height]];
  }

  bottomxys() {
    const {
      x, y, width, height,
    } = this;
    return [[x, y + height], [x + width, y + height]];
  }

  leftxys() {
    const {
      x, y, height,
    } = this;
    return [[x, y], [x, y + height]];
  }
}

function drawFontLine(type, tx, ty, align, valign, blheight, blwidth) {
  const floffset = { x: 0, y: 0 };
  if (type === 'underline') {
    if (valign === 'bottom') {
      floffset.y = 0;
    } else if (valign === 'top') {
      floffset.y = -(blheight + 2);
    } else {
      floffset.y = -blheight / 2;
    }
  } else if (type === 'strike') {
    if (valign === 'bottom') {
      floffset.y = blheight / 2;
    } else if (valign === 'top') {
      floffset.y = -((blheight / 2) + 2);
    }
  }

  if (align === 'center') {
    floffset.x = blwidth / 2;
  } else if (align === 'right') {
    floffset.x = blwidth;
  }
  this.line(
    [tx - floffset.x, ty - floffset.y],
    [tx - floffset.x + blwidth, ty - floffset.y],
  );
}

class Draw {
  constructor(el, width, height) {
    this.el = el;
    this.ctx = el.getContext('2d');
    this.resize(width, height);
    this.ctx.scale(dpr(), dpr());
		this.ctx.onclick = e=>{
			let p = this.getEventPosition(e);
      let result = this.draw(p);
      console.log(result);
		};

    this.oldDistance = null;
    this.oldImageRect = null;
  }

  resize(width, height) {
    // console.log('dpr:', dpr);
    this.el.style.width = `${width}px`;
    this.el.style.height = `${height}px`;
    this.el.width = npx(width);
    this.el.height = npx(height);
  }

  clear() {
    const { width, height } = this.el;
    this.ctx.clearRect(0, 0, width, height);
    return this;
  }

  attr(options) {
    Object.assign(this.ctx, options);
    return this;
  }

  save() {
    this.ctx.save();
    this.ctx.beginPath();
    return this;
  }

  restore() {
    this.ctx.restore();
    return this;
  }

  beginPath() {
    this.ctx.beginPath();
    return this;
  }

  translate(x, y) {
    this.ctx.translate(npx(x), npx(y));
    return this;
  }

  scale(x, y) {
    this.ctx.scale(x, y);
    return this;
  }

  clearRect(x, y, w, h) {
    this.ctx.clearRect(x, y, w, h);
    return this;
  }

  fillRect(x, y, w, h) {
    this.ctx.fillRect(npx(x) - 0.5, npx(y) - 0.5, npx(w), npx(h));
    return this;
  }

  fillText(text, x, y) {
    this.ctx.fillText(text, npx(x), npx(y));
    return this;
  }

  /*
  * mtxt:需要居中对齐的字符串
  * box:canvas的宽度
  * ch:canvas的宽度
  * */
  canvasDisttibuted(mtxt,cw, tx, ty, attr={},size){
    const {
      align,valign,font, strike, underline
    } = attr;

    let txtArr = parseTexts(mtxt,true);
    var strL = txtArr.length;
    let textWidth = 0;
    for(var i = 0; i<strL; i++){
      textWidth += this.ctx.measureText(txtArr[i]).width;
    }

    let xSpaceWidth = (cw - textWidth)/(strL-1);//字符之间间隔的宽度
    console.log("tx......", tx);
    console.log("ty......", ty);
    console.log("strL......", strL);
    console.log("mtxt......", mtxt);
    console.log("textWidth......", textWidth);
    console.log("xSpaceWidth......", xSpaceWidth);
    let xStart = tx;
    
    for(var i = 0; i<strL; i++){
      let txtWidth = this.ctx.measureText(txtArr[i]).width;

      if (strL == 1) { //针对只有一个元素的字符串居中处理
        xStart = xStart + cw/2-txtWidth/2;
      }
      this.fillText(txtArr[i],xStart,ty);
      console.log("xStart......", xStart);
      console.log("txtArr[i]......", txtArr[i]);
      console.log("txtWidth......", txtWidth);
      if (strike) {
        drawFontLine.call(this, 'strike', xStart, ty, align, valign, font.size, txtWidth);
      }
      if (underline) {
        drawFontLine.call(this, 'underline', xStart, ty, align, valign, font.size, txtWidth);
      }
      xStart = xStart + txtWidth + xSpaceWidth;
    }
  }

  //设置文本分散对齐
  setTextDisttibuted(mtxt, box, attr = {}, textWrap = true,data,distance){
    const { ctx } = this;
    const {
      align,valign,font, color, strike, underline
    } = attr;
    let alignUse = align;
    if (align === 'horizontal-disttibuted') {
      alignUse = 'left'
    }

    let valignUse = valign;
    if (valign == 'vertical-justifyAlign' || valign == 'vertical-disttibuted') {
      valignUse = 'middle'
    }

    ctx.save();
    ctx.beginPath();
    
    this.attr({
      textAlign: alignUse,
      textBaseline: valignUse,
      font: `${font.italic ? 'italic' : ''} ${font.bold ? 'bold' : ''} ${npx(font.size)}px ${font.name}`,
      fillStyle: color,
      strokeStyle: color,
    });

    //先设置水平显示
    const tx = box.textx(align);
    const txts = `${mtxt}`.split('\n');

    let boxWidth = npx(box.width)-10;
    const ntxts = [];
    txts.forEach((it) => {
      const txtWidth = ctx.measureText(it).width;
      if ((align === 'horizontal-disttibuted' || textWrap) && txtWidth > boxWidth) { //水平
        let txtArr = parseTexts(it);
        let textLine = { w: 0, len: 0, start: 0 };
        let endLine = 0;
        for (let i = 0; i < txtArr.length; i += 1) {
          if (textLine.w >= boxWidth) {
            ntxts.push(txtArr.slice(textLine.start, i).join(''));
            textLine = { w: 0, len: 0, start: i };
            endLine = i;
          }
          textLine.len += 1;
          // console.log("it[i]......",txtArr[i]);
          // console.log("ctx.measureText(it[i]).width......",ctx.measureText(txtArr[i]).width);
          textLine.w += ctx.measureText(txtArr[i]).width;
          if (txtArr.length > i+1) {
            let nextW = ctx.measureText(txtArr[i+1]).width
            if (textLine.w+nextW > boxWidth) {
              ntxts.push(txtArr.slice(textLine.start, i).join(''));
              textLine = { w: 0, len: 0, start: i };
              endLine = i;
            }
          }
        }
        if (textLine.w > 0) {
          ntxts.push(txtArr.slice(endLine, txtArr.length-1).join(''));
        }
      }else{
        ntxts.push(it);
      }
    });
    let ty,textHeight,ySpaceWidth;
    if (valign == 'vertical-justifyAlign' || valign == 'vertical-disttibuted') {
      if (ntxts.length<=1 && valign == 'vertical-disttibuted') {
        ySpaceWidth = 2;//字符之间间隔的高度
        textHeight = (ntxts.length - 1) * (font.size + ySpaceWidth);
        ty = box.texty(valign, textHeight);
      }else{
        ty = box.texty('top')+5;
        textHeight = ntxts.length * font.size + 5;
        ySpaceWidth = (box.height - textHeight)/(ntxts.length - 1);//字符之间间隔的高度
      }
    } else {
      ySpaceWidth = 2;//字符之间间隔的高度
      textHeight = (ntxts.length - 1) * (font.size + ySpaceWidth);
      ty = box.texty(valign, textHeight);
    }
    
    ntxts.forEach((txt) => {
      if (align === 'horizontal-disttibuted') {
        this.canvasDisttibuted(txt,boxWidth,tx,ty,attr);
        ty += font.size + ySpaceWidth;
      } else {
        const txtWidth = ctx.measureText(txt).width;
        this.fillText(txt, tx, ty);
        if (strike) {
          drawFontLine.call(this, 'strike', tx, ty, align, valign, font.size, txtWidth);
        }
        if (underline) {
          drawFontLine.call(this, 'underline', tx, ty, align, valign, font.size, txtWidth);
        }
        ty += font.size + ySpaceWidth;
      }
      
    });
    ctx.restore();
    //再设置垂直显示
  }

  /*
    txt: render text
    box: DrawBox
    attr: {
      align: left | center | right
      valign: top | middle | bottom
      color: '#333333',
      strike: false,
      underline: false,
      cellslash:false, //添加单元格斜线处理
      cellslashdrawstart:'lefttop',
      cellimage:false, //添加单元格图片
      font: {
        name: 'Arial',
        size: 14,
        bold: false,
        italic: false,
      }
    }
    textWrap: text wrapping
  */
  text(mtxt, box, attr = {}, textWrap = true,data,distance) {
    console.log("draw text attr......",attr);
    // console.log("draw text box......",box);
    // console.log("draw text mtxt......",mtxt);
    // debugger

    const { ctx } = this;
    const {
      font, color, strike, underline,cellslash,cellimage
    } = attr;
    let align = attr.align;
    if (align === 'horizontal-justifyAlign') {
      align = 'left';
    }
    let valign = attr.valign;

    let newAttr = {...attr,align,valign};
    if (cellslash) {
      if (align === 'horizontal-disttibuted') {
        newAttr.align = 'center';
      }
      if (valign == 'vertical-justifyAlign' || valign == 'vertical-disttibuted') {
        newAttr.valign = 'middle'
      }
      this.addCellSlash(mtxt, box, newAttr, textWrap,distance);
    }else if(cellimage){
      if (align === 'horizontal-disttibuted') {
        newAttr.align = 'center';
      }
      if (valign == 'vertical-justifyAlign' || valign == 'vertical-disttibuted') {
        newAttr.valign = 'middle'
      }
      this.addCellImage(mtxt, box, newAttr, textWrap,data,distance);
    }else{
      if (align == 'horizontal-disttibuted' || //水平分散对齐
      valign == 'vertical-justifyAlign' || valign == 'vertical-disttibuted') { //垂直分散对齐
        this.setTextDisttibuted(mtxt, box, newAttr, textWrap,data,distance)
      }else {
        const tx = box.textx(align);
        ctx.save();
        ctx.beginPath();
        
        this.attr({
          textAlign: align,
          textBaseline: valign,
          font: `${font.italic ? 'italic' : ''} ${font.bold ? 'bold' : ''} ${npx(font.size)}px ${font.name}`,
          fillStyle: color,
          strokeStyle: color,
        });
        const txts = `${mtxt}`.split('\n');
        const biw = box.innerWidth();
        let boxWidth = npx(box.width)-10;
        const ntxts = [];
        txts.forEach((it) => {
          const txtWidth = ctx.measureText(it).width;
          let txtArr = parseTexts(it);
          if (textWrap && txtWidth > boxWidth) {
            let textLine = { w: 0, len: 0, start: 0 };
            let endLine = 0;
            for (let i = 0; i < txtArr.length; i += 1) {
              if (textLine.w >= boxWidth) {
                ntxts.push(txtArr.slice(textLine.start, i).join(''));
                textLine = { w: 0, len: 0, start: i };
                endLine = i;
              }
              textLine.len += 1;
              // console.log("it[i]......",txtArr[i]);
              // console.log("ctx.measureText(it[i]).width......",ctx.measureText(txtArr[i]).width);
              textLine.w += ctx.measureText(txtArr[i]).width;
              if (txtArr.length > i+1) {
                let nextW = ctx.measureText(txtArr[i+1]).width
                if (textLine.w+nextW > boxWidth) {
                  ntxts.push(txtArr.slice(textLine.start, i).join(''));
                  textLine = { w: 0, len: 0, start: i };
                  endLine = i;
                }
              }
            }
            if (textLine.w > 0) {
              ntxts.push(txtArr.slice(endLine, txtArr.length-1).join(''));
            }
          } else {
            ntxts.push(it);
          }
        });
        console.log("ntxts......",ntxts);
        const txtHeight = (ntxts.length - 1) * (font.size + 2);
        let ty = box.texty(valign, txtHeight);
        ntxts.forEach((txt) => {
          const txtWidth = ctx.measureText(txt).width;
          this.fillText(txt, tx, ty);
          if (strike) {
            drawFontLine.call(this, 'strike', tx, ty, align, valign, font.size, txtWidth);
          }
          if (underline) {
            drawFontLine.call(this, 'underline', tx, ty, align, valign, font.size, txtWidth);
          }
          ty += font.size + 2;
        });
        ctx.restore();
      }
      
    }
    
    return this;
  }

  border(style, color) {
    const { ctx } = this;
    ctx.lineWidth = thinLineWidth;
    ctx.strokeStyle = color;
    // console.log('style:', style);
    if (style === 'medium') {
      ctx.lineWidth = npx(2) - 0.5;
    } else if (style === 'thick') {
      ctx.lineWidth = npx(3);
    } else if (style === 'dashed') {
      ctx.setLineDash([npx(3), npx(2)]);
    } else if (style === 'dotted') {
      ctx.setLineDash([npx(1), npx(1)]);
    } else if (style === 'double') {
      ctx.setLineDash([npx(2), 0]);
    }
    return this;
  }

  line(...xys) {
    const { ctx } = this;
    if (xys.length > 1) {
      ctx.beginPath();
      const [x, y] = xys[0];
      ctx.moveTo(npxLine(x), npxLine(y));
      for (let i = 1; i < xys.length; i += 1) {
        const [x1, y1] = xys[i];
        ctx.lineTo(npxLine(x1), npxLine(y1));
      }
      ctx.stroke();
    }
    return this;
  }

  strokeBorders(box) {
    const { ctx } = this;
    ctx.save();
    // border
    let {
      borderTop, borderRight, borderBottom, borderLeft,
    } = box;
    if (borderTop) {
      if (!Array.isArray(borderTop)) {
        borderTop = [borderTop.style,borderTop.color];
      }
      console.log('...borderTop:', ...borderTop);
      console.log('borderTop:', borderTop);
      this.border(...borderTop);
      console.log('box.topxys:', box.topxys());
      this.line(...box.topxys());
    }
    if (borderRight) {
      if (!Array.isArray(borderRight)) {
        borderRight = [borderRight.style,borderRight.color];
      }
      this.border(...borderRight);
      this.line(...box.rightxys());
    }
    if (borderBottom) {
      if (!Array.isArray(borderBottom)) {
        borderBottom = [borderBottom.style,borderBottom.color];
      }
      this.border(...borderBottom);
      this.line(...box.bottomxys());
    }
    if (borderLeft) {
      if (!Array.isArray(borderLeft)) {
        borderLeft = [borderLeft.style,borderLeft.color];
      }
      this.border(...borderLeft);
      this.line(...box.leftxys());
    }
    ctx.restore();
  }

  dropdown(box) {
    const { ctx } = this;
    const {
      x, y, width, height,
    } = box;
    const sx = x + width - 15;
    const sy = y + height - 15;
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(npx(sx), npx(sy));
    ctx.lineTo(npx(sx + 8), npx(sy));
    ctx.lineTo(npx(sx + 4), npx(sy + 6));
    ctx.closePath();
    ctx.fillStyle = 'rgba(0, 0, 0, .45)';
    ctx.fill();
    ctx.restore();
  }

  error(box) {
    const { ctx } = this;
    const { x, y, width } = box;
    const sx = x + width - 1;
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(npx(sx - 8), npx(y - 1));
    ctx.lineTo(npx(sx), npx(y - 1));
    ctx.lineTo(npx(sx), npx(y + 8));
    ctx.closePath();
    ctx.fillStyle = 'rgba(255, 0, 0, .65)';
    ctx.fill();
    ctx.restore();
  }

  frozen(box,color) {
    const { ctx } = this;
    const { x, y, width } = box;
    const sx = x + width - 1;
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(npx(sx - 15), npx(y - 1));
    ctx.lineTo(npx(sx), npx(y - 1));
    ctx.lineTo(npx(sx), npx(y + 15));
    ctx.closePath();
    ctx.fillStyle = color?color:'rgba(0, 255, 0, .85)';
    ctx.fill();
    ctx.restore();
  }

  disabled(box,color) {
    const { ctx } = this;
    const { x, y, width,height } = box;
    const sx = x + width - 1;
    ctx.save();
    ctx.beginPath();

    ctx.rect(x,y,width,height); 

    ctx.closePath();
    ctx.fillStyle = color?color:'rgba(0, 255, 0, .85)';
    ctx.fill();
    ctx.restore();
  }

  rect(box, dtextcb) {
    const { ctx } = this;
    const {
      x, y, width, height, bgcolor,
    } = box;
    ctx.save();
    ctx.beginPath();
    ctx.fillStyle = bgcolor || '#fff';
    ctx.rect(npxLine(x + 1), npxLine(y + 1), npx(width - 2), npx(height - 2));
    ctx.clip();
    ctx.fill();
    dtextcb();
    ctx.restore();
  }
	getEventPosition(e) {
			var x, y;
			if (e.layerX || e.layerX == 0) {
					x = e.layerX;
					y = e.layerY;
			} else if (e.offsetX || e.offsetX == 0) { // Opera
					x = e.offsetX;
					y = e.offsetY;
			}
			return { x: x, y: y };
	}
	draw(p) {
			var who = [];
			ctx.clearRect(0, 0, dom.canvas[0].width, dom.canvas[0].height);
			arr.forEach(function(v, i) {
					ctx.beginPath();
					ctx.rect(v.x, v.y, v.width, v.height);
					ctx.stroke();
					if (p && ctx.isPointInPath(p.x, p.y)) {
							//如果传入了事件坐标，就用isPointInPath判断一下
							//如果当前环境覆盖了该坐标，就将当前环境的index值放到数组里
							who.push(i);
					}
			});
			//根据数组中的index值，可以到arr数组中找到相应的元素。
			return who;
	}
  //添加添加列按钮
	addColImg(x,y,width,height){
    x = npx(x);
    y = npx(y);
		const { ctx } = this;

		let ax = x+5+10;
		let ay = 12+y;
		ctx.beginPath();
		ctx.moveTo(ax-5,y+height/2+2);
		ctx.lineTo(ax-5+10,y+height/2+2);
		ctx.stroke();

		ctx.beginPath();
		ctx.moveTo(ax,y+height/2-5+2);
		ctx.lineTo(ax,y+height/2+5+2);
		ctx.stroke();

		ctx.beginPath();
		ctx.arc(ax,ay,10,0,2*Math.PI);
		ctx.stroke();
	}

  fillSlashText(ctx,text, x, y){
    ctx.fillText(text, npx(x), npx(y));
  }

  drawCellSlash(ctx,mtxt, box, attr = {}, textWrap = true,distance){
    const {
      cellslashdrawstart
    } = attr;
    ctx.save();
    ctx.beginPath();

    let texts = `${mtxt}`.split('|');
    if (texts && texts.length>=2) {
      if (texts.length==2) {
        if (cellslashdrawstart=='leftbottom') {
          ctx.moveTo(box.x,box.y+box.height);
          ctx.lineTo(box.x+box.width,box.y);

          this.fillSlashText(ctx,texts[0], box.x+10, box.y+20);
          const txtWidth = ctx.measureText(texts[1]).width;
          this.fillSlashText(ctx,texts[1], box.x+box.width-txtWidth-10, box.y+box.height-20);

          // console.log("addCellSlash text txtWidth......",txtWidth);
        }else{
          ctx.moveTo(box.x,box.y);
          ctx.lineTo(box.x+box.width,box.y+box.height);

          this.fillSlashText(ctx,texts[0], box.x+10, box.y+box.height-20);
          const txtWidth = ctx.measureText(texts[1]).width;
          this.fillSlashText(ctx,texts[1], box.x+box.width-txtWidth-10, box.y+20);

          // console.log("addCellSlash text txtWidth......",txtWidth);
        }
        
        ctx.stroke();
      }else if (texts.length==3) {
        if (cellslashdrawstart=='leftbottom') {
          ctx.moveTo(box.x,box.y+box.height);
          ctx.lineTo(box.x+box.width/2,box.y);
          ctx.moveTo(box.x,box.y+box.height);
          ctx.lineTo(box.x+box.width,box.y+box.height/2);

          this.fillSlashText(ctx,texts[0], box.x+10, box.y+20);
          const txtWidth = ctx.measureText(texts[1]).width;
          this.fillSlashText(ctx,texts[1], box.x+box.width-txtWidth-10, box.y+20);
          const txtWidth1 = ctx.measureText(texts[2]).width;
          this.fillSlashText(ctx,texts[2], box.x+box.width-txtWidth1-10, box.y+box.height-20);
        }else{
          ctx.moveTo(box.x,box.y);
          ctx.lineTo(box.x+box.width/2,box.y+box.height);
          ctx.moveTo(box.x,box.y);
          ctx.lineTo(box.x+box.width,box.y+box.height/2);

          this.fillSlashText(ctx,texts[0], box.x+10, box.y+box.height-20);
          const txtWidth = ctx.measureText(texts[1]).width;
          this.fillSlashText(ctx,texts[1], box.x+box.width-txtWidth-10, box.y+box.height-30);
          const txtWidth1 = ctx.measureText(texts[2]).width;
          this.fillSlashText(ctx,texts[2], box.x+box.width-txtWidth1-10, box.y+20);
        }

        ctx.stroke();
      }else {

      }
    }
    ctx.restore();
  }

  //添加单元格斜线
  addCellSlash(mtxt, box, attr = {}, textWrap = true,distance){
    const { ctx } = this;
    const {
      align, valign, font, color, strike, underline,cellslashdrawstart
    } = attr;
    this.attr({
      textAlign: align,
      textBaseline: valign,
      font: `${font.italic ? 'italic' : ''} ${font.bold ? 'bold' : ''} ${npx(font.size)}px ${font.name}`,
      fillStyle: color,
      strokeStyle: color,
    });
    //先画显示的画布斜线
    this.drawCellSlash(ctx,mtxt, box, attr, textWrap,distance);
    // const {
    //   align, valign, font, color, strike, underline,cellslashdrawstart
    // } = attr;
    // this.attr({
    //   textAlign: align,
    //   textBaseline: valign,
    //   font: `${font.italic ? 'italic' : ''} ${font.bold ? 'bold' : ''} ${npx(font.size)}px ${font.name}`,
    //   fillStyle: color,
    //   strokeStyle: color,
    // });
    // ctx.save();
    // ctx.beginPath();

    // let texts = `${mtxt}`.split('|');
    // if (texts && texts.length>=2) {
    //   if (texts.length==2) {
    //     if (cellslashdrawstart=='leftbottom') {
    //       ctx.moveTo(box.x,box.y+box.height);
    //       ctx.lineTo(box.x+box.width,box.y);

    //       this.fillText(texts[0], box.x+10, box.y+20);
    //       const txtWidth = ctx.measureText(texts[1]).width;
    //       this.fillText(texts[1], box.x+box.width-txtWidth-10, box.y+box.height-20);

    //       // console.log("addCellSlash text txtWidth......",txtWidth);
    //     }else{
    //       ctx.moveTo(box.x,box.y);
    //       ctx.lineTo(box.x+box.width,box.y+box.height);

    //       this.fillText(texts[0], box.x+10, box.y+box.height-20);
    //       const txtWidth = ctx.measureText(texts[1]).width;
    //       this.fillText(texts[1], box.x+box.width-txtWidth-10, box.y+20);

    //       // console.log("addCellSlash text txtWidth......",txtWidth);
    //     }
        
    //     ctx.stroke();
    //   }else if (texts.length==3) {
    //     if (cellslashdrawstart=='leftbottom') {
    //       ctx.moveTo(box.x,box.y+box.height);
    //       ctx.lineTo(box.x+box.width/2,box.y);
    //       ctx.moveTo(box.x,box.y+box.height);
    //       ctx.lineTo(box.x+box.width,box.y+box.height/2);

    //       this.fillText(texts[0], box.x+10, box.y+20);
    //       const txtWidth = ctx.measureText(texts[1]).width;
    //       this.fillText(texts[1], box.x+box.width-txtWidth-10, box.y+20);
    //       const txtWidth1 = ctx.measureText(texts[2]).width;
    //       this.fillText(texts[2], box.x+box.width-txtWidth1-10, box.y+box.height-20);
    //     }else{
    //       ctx.moveTo(box.x,box.y);
    //       ctx.lineTo(box.x+box.width/2,box.y+box.height);
    //       ctx.moveTo(box.x,box.y);
    //       ctx.lineTo(box.x+box.width,box.y+box.height/2);

    //       this.fillText(texts[0], box.x+10, box.y+box.height-20);
    //       const txtWidth = ctx.measureText(texts[1]).width;
    //       this.fillText(texts[1], box.x+box.width-txtWidth-10, box.y+box.height-30);
    //       const txtWidth1 = ctx.measureText(texts[2]).width;
    //       this.fillText(texts[2], box.x+box.width-txtWidth1-10, box.y+20);
    //     }

    //     ctx.stroke();
    //   }else {

    //   }
    // }
    // ctx.restore();
    //单独创建新画布，画出斜线生成图片，保存
    const clipCanvasCache = document.createElement('canvas')
    clipCanvasCache.width = box.width
    clipCanvasCache.height = box.height

    console.log("clipCanvasCache......",clipCanvasCache);

    const clipContextCache = clipCanvasCache.getContext('2d');
    Object.assign(clipContextCache, {
      textAlign: align,
      textBaseline: valign,
      font: `${font.italic ? 'italic' : ''} ${font.bold ? 'bold' : ''} ${npx(font.size)}px ${font.name}`,
      fillStyle: color,
      strokeStyle: color,
    });
    this.drawCellSlash(clipContextCache,mtxt, {x:0,y:0,width:box.width,height:box.height}, attr, textWrap,distance);

    console.log("clipContextCache......",clipContextCache);
    const data = clipContextCache.getImageData(0,0, clipCanvasCache.width, clipCanvasCache.height)

    console.log("clipContextCache data......",data);
    let base64Img= clipCanvasCache.toDataURL('image/png', 1)
    console.log("addCellSlash text base64Img......",base64Img);
    box.setImgBase64(base64Img);


    
    // //将生成的单元格斜线转换成图片，存储进box
    // const itemCanvas = this.el;  //canvas对象
    // const itemWitdh = itemCanvas.width
    // const itemHeight = itemCanvas.height
    // const itemBase64 = itemCanvas.toDataURL('image/png')

    // const img = new Image();
    // img.src = itemBase64
    // img.crossOrigin = "anonymous";
    // img.onload = () => {
    //   const clipCanvas = document.createElement('canvas')
    //   clipCanvas.width = box.width
    //   clipCanvas.height = box.height
    //   const data = ctx.getImageData(box.x+60+distance.left,box.y+20+distance.top, clipCanvas.width, clipCanvas.height)
    //   const clipContext = clipCanvas.getContext('2d')
    //   clipContext.putImageData(data, 0, 0)
    //   let base64Img= clipCanvas.toDataURL('image/png', 1)
    //   // console.log("addCellSlash text base64Img......",base64Img);
    //   box.setImgBase64(base64Img);
    // }
    return this;
  }

  //添加单元格图片
  addCellImage(mtxt, box, attr = {}, textWrap = true,data,distance){

    // console.log("addCellImage box.y......",box.y);
    if (!mtxt || mtxt==' ') {
      return;
    }
    let _this = this;
    const { ctx } = this;
    const {
      align, valign, font, color, strike, underline,cellslashdrawstart
    } = attr;

    this.attr({
      textAlign: align,
      textBaseline: valign,
      font: `${font.italic ? 'italic' : ''} ${font.bold ? 'bold' : ''} ${npx(font.size)}px ${font.name}`,
      fillStyle: color,
      strokeStyle: color,
    });

    //将路径转换成图片，显示在画布上
    const img = new Image();
    img.onerror = (onerror) => {
      // console.log("addCellImage onerror......",onerror);
      img.src=require('../../assets/default_icon.png');
      img.onerror=null
    }
    img.crossOrigin = "anonymous";
    img.onload = (onload) => {
      ctx.save();

      // if (_this.oldDistance) {
      //   console.log("addCellImage oldDistance......",_this.oldDistance.top, _this.oldDistance.left);
      // }
      // _this.oldDistance = distance;
      // ctx.drawImage(img, box.x+60+distance.left,box.y+20+distance.top, box.width,box.height)
      // console.log("addCellImage distance   ......",distance.top, distance.left);}

      if (_this.oldDistance && (_this.oldDistance.left == distance.left && _this.oldDistance.top != distance.top)) {
        // ctx.clearRect(box.x+60,box.y+20+_this.oldDistance.top, box.width,box.height);
        ctx.drawImage(img, box.x+60,box.y+20+distance.top, box.width,box.height)
      }else if (_this.oldDistance && (_this.oldDistance.top == distance.top && _this.oldDistance.left != distance.left)){
        // ctx.clearRect(box.x+60+_this.oldDistance.left,box.y+20, box.width,box.height);
        ctx.drawImage(img, box.x+60+distance.left,box.y+20, box.width,box.height)
      } else{
        // ctx.clearRect(box.x+60+distance.left,box.y+20+distance.top, box.width,box.height);
        ctx.drawImage(img, box.x+60+distance.left,box.y+20+distance.top, box.width,box.height)
      }
      _this.oldDistance = distance;
      ctx.restore();
    }
    var reUrl = /(http|https):\/\/([\w.]+\/?)\S*/;// /^(https|http):\/\/([\w-]+(\.[\w-]+)*\/?)+(\?([\w\-\.,@?^=%&:\/~\+#]*)+)?$/;
    if (reUrl.test(mtxt)) {//IsExstsFile(val) && 
      img.src = mtxt;
    }else{
      img.src = data.ossUrl+mtxt;
    }
    // console.log("addCellImage img.src......",img.src);

    // ctx.save();
    // ctx.drawImage(img, box.x+60,box.y+20, box.width,box.height)
    // ctx.restore();
    
    return this;
  }

  //添加块边框及文字
  addBlockBorderText(selectRect,type, blockText){
    let text = '块';
    if (type == 'block') {
      text = '块';
    }else if (type == 'rowCycleBlock') {
      text = '行循环块';
    }else if (type == 'columnCycleBlock') {
      text = '列循环块';
    }else if (type == 'customVariableBlock') {
      text = blockText;
    }

    const { ctx } = this;

    this.attr({
      fillStyle: '#4e72fb'
    });

    ctx.beginPath();
    this.fillText(text, selectRect.x, selectRect.y-5);
    ctx.rect(selectRect.x, selectRect.y, selectRect.width, selectRect.height);
    ctx.lineWidth = 2;
    ctx.strokeStyle = '#4e72fb';
    ctx.stroke();
  }

  //添加表单配置区域边框及文字
  addFormConfigBorderText(selectRect,formName,type){
    const { ctx } = this;

    let textStr = '';
    let lineWidth = 1;
    let strokeStyle = '#4e72fb';
    if (type=='area') {
      textStr = '表单配置区域';
      if (formName) {
        textStr = formName+'表配置区域';
      }
      lineWidth = 2;
    } else if (type=='title') {
      strokeStyle = '#FF00FF';
      textStr = formName || '标题行'
    } else if (type=='title-row') {
      strokeStyle = '#4e72fb';
      textStr = formName || '字段名称行'
    } else if (type=='first-row') {
      strokeStyle = '#4e72fb';
      textStr = formName || '数据起始行'
    } else {
      
    }

    this.attr({
      fillStyle: strokeStyle
    });
    if (type=='area') {
      ctx.setLineDash([10, 5]);
    }
    ctx.beginPath();
    if (type=='area') {
      this.fillText(textStr, selectRect.x, selectRect.y-5);
    }else{
      this.fillText(textStr, selectRect.x+2, selectRect.y+10);
    }
    
    ctx.rect(selectRect.x, selectRect.y, selectRect.width, selectRect.height);
    ctx.lineWidth = lineWidth;
    ctx.strokeStyle = strokeStyle;
    ctx.stroke();
  }
}

export default {};
export {
  Draw,
  DrawBox,
  thinLineWidth,
  npx,
};
